import React from "react";
import WebModalForm from "../forms/webmodalform";

const WebModal = ({ modal, toggleModal, customHeading  }) => {
  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  return (
    <>
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay" />
          <div className="modal-content">
            <button className="absolute top-[-14px] right-[-10px] w-[45px] z-[2]" onClick={toggleModal}>
              <img src="https://glocify.com/images/cross.svg" alt="cross-icon" className="" />
            </button>
            <div className="lg:grid grid-cols-2">
              <div className="bg-[linear-gradient(269.02deg,#7c46ef_25.44%,#9a4aff_64%)] lg:rounded-l-[32px] lg:rounded-tr-[0] rounded-t-[20px] lg:px-[50px] px-4 modal-background relative">
                <div className="z-10">
                <h2 className="lg:text-[27px] text-[19px] text-white font-semibold lg:leading-[40px] leading-[26px] lg:pt-[35px] py-4">
                        Start Building Your App With Us!
                      </h2>
                      <p className="text-base font-normal pt-[0px] text-white lg:block hidden">
                        Partner with Glocify, and we'll bring your app to life—fast and flawlessly
                      </p>
                  <div className="max-w-[340px] absolute bottom-[-1px] z-[2] lg:block hidden">
                    <img src="https://glocify.com/images/hand-phone.png" alt="hand-phone" />
                  </div>
                </div>
              </div>
              <div className="lg:p-[50px] p-6 bg-white rounded-[20px]">                
                <WebModalForm formId={19145} formSubject={"Mobile App Talk to an Expert Form or Modal Form"} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WebModal;

